import { createReducer } from 'typesafe-actions';

import {
  setThemeSpotlightVisited,
  setThemeSpotlightExpired,
  setCurrencySpotlightExpired,
  setCurrencySpotlightVisited,
  setActivityExportSpotlightExpired,
  setActivityExportSpotlightVisited,
  setCsprClickBarSpotlightExpired,
  setCsprClickBarSpotlightVisited,
  setAssociatedKeysSpotlightExpired,
  setAssociatedKeysSpotlightVisited,
  setAccountsPageSpotlightVisited,
  setAccountsPageSpotlightExpired,
  setNodeLunchSpotlightVisited,
  setNodeLunchSpotlightExpired,
  setNodeLunchSpotlightIgnored,
} from './actions';
import { isExpired } from '../utils';

export type StateKey =
  | 'theme'
  | 'currency'
  | 'activityExport'
  | 'csprClickBar'
  | 'associatedKey'
  | 'accountsPage'
  | 'nodeLunch';

export type StateValue = {
  visited: boolean;
  expired: boolean;
  ignored?: boolean;
};

export type State = Record<StateKey, StateValue>;

const initialState: State = {
  theme: {
    visited: false,
    expired: true,
  },
  currency: {
    visited: false,
    expired: true,
  },
  activityExport: {
    visited: false,
    expired: true,
  },
  csprClickBar: {
    visited: false,
    expired: true,
  },
  associatedKey: {
    visited: false,
    expired: true,
  },
  accountsPage: {
    visited: false,
    expired: true,
  },
  nodeLunch: {
    visited: false,
    expired: false,
    ignored: true,
  },
};

export default createReducer(initialState)
  .handleAction(
    setThemeSpotlightExpired,
    (state): State => ({
      ...state,
      theme: {
        ...state.theme,
        expired: isExpired({
          buildDate: config.spotlight_theme_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setCurrencySpotlightExpired,
    (state): State => ({
      ...state,
      currency: {
        ...state.currency,
        expired: isExpired({
          buildDate: config.spotlight_currency_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setActivityExportSpotlightExpired,
    (state): State => ({
      ...state,
      activityExport: {
        ...state.activityExport,
        expired: isExpired({
          buildDate: config.spotlight_activity_export_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setCsprClickBarSpotlightExpired,
    (state): State => ({
      ...state,
      csprClickBar: {
        ...state.csprClickBar,
        expired: isExpired({
          buildDate: config.spotlight_cspr_click_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setAssociatedKeysSpotlightExpired,
    (state): State => ({
      ...state,
      associatedKey: {
        ...state.associatedKey,
        expired: isExpired({
          buildDate: config.spotlight_associated_keys_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setAccountsPageSpotlightExpired,
    (state): State => ({
      ...state,
      accountsPage: {
        ...state.accountsPage,
        expired: isExpired({
          buildDate: config.spotlight_accounts_page_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setNodeLunchSpotlightExpired,
    (state): State => ({
      ...state,
      nodeLunch: {
        ...state.nodeLunch,
        expired: isExpired({
          buildDate: config.spotlight_node_lunch_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setThemeSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      theme: {
        ...state.theme,
        visited: payload,
      },
    })
  )
  .handleAction(
    setCurrencySpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      currency: {
        ...state.currency,
        visited: payload,
      },
    })
  )
  .handleAction(
    setActivityExportSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      activityExport: {
        ...state.activityExport,
        visited: payload,
      },
    })
  )
  .handleAction(
    setCsprClickBarSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      csprClickBar: {
        ...state.csprClickBar,
        visited: payload,
      },
    })
  )
  .handleAction(
    setAssociatedKeysSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      associatedKey: {
        ...state.associatedKey,
        visited: payload,
      },
    })
  )
  .handleAction(
    setAccountsPageSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      accountsPage: {
        ...state.accountsPage,
        visited: payload,
      },
    })
  )
  .handleAction(
    setNodeLunchSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      nodeLunch: {
        ...state.nodeLunch,
        visited: payload,
      },
    })
  )
  .handleAction(
    setNodeLunchSpotlightIgnored,
    (state, { payload }): State => ({
      ...state,
      nodeLunch: {
        ...state.nodeLunch,
        ignored: payload,
      },
    })
  );
